export default "__VITE_ASSET__e74d2ae2__"